import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import { tagsAdd, tagsLoadAll } from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(tagsAdd.type, send, socket);
  yield takeEvery(tagsLoadAll.type, send, socket);
}
